module.exports = __webpack_public_path__ + "static/media/lesson_chapter_5.136474cb.png";